import React, {PropTypes} from 'react';
import Level from './level';
import Translate from 'react-translate-component';

class LoyaltyPointsLevels extends React.Component {
  static propTypes = {
    levels: PropTypes.array.isRequired,
    points: PropTypes.number.isRequired,
    selected: PropTypes.number,
    setSelectedLevel: PropTypes.func.isRequired,
    currentLevelIndex: PropTypes.number
  };

  selectedLevel (level) {
    return level === this.props.selected ? ' active' : '';
  }

  trailingText (level) {
    if (level === this.props.currentLevelIndex) {
      return <Translate className='level-trailing' content='LEVEL_CURRENT_LEVEL' />;
    }

    if (level === this.props.currentLevelIndex + 1) {
      return <Translate className='level-trailing' content='LEVEL_NEXT_LEVEL' />;
    }
  }

  renderLevels () {
    let levels = [];
    this.props.levels.forEach((level, index) => levels.push(
      <Level
        key={level.title}
        level={level}
        levelNumber={index}
        selected={this.selectedLevel(index)}
        setSelectedLevel={this.props.setSelectedLevel}
        trailingText={this.trailingText(index)}
      />
    ));

    return levels;
  }

  render () {
    return (
      <div className='loyalty-points-overview-levels'>
        {this.renderLevels()}
      </div>);
  }
}

export default LoyaltyPointsLevels;



/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/overview/levels.js
 **/